module.exports = __webpack_public_path__ + "img/mapHerault.274f68c.jpg";